import { FormGroup } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { getControl } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { CkNormeValues } from '../models/amm-controllo.type';

const AMM_CTRL_PATH = 'my_SezioneI__Rilevazione.my_AmministrazioneControllo';

/**
 * Filters emissions when the current ckNorme value does not match expectedNorme.
 * Use in pipe chains of common amm-controllo listeners that must only run for a specific norme type.
 * The control reference is captured once; .value is read at each emission so the check is always current.
 */
export function withCkNormeGuard(form: FormGroup, expectedNorme: CkNormeValues) {
    const ckNormeControl = getControl(form, `${AMM_CTRL_PATH}.my_CkNorme`);
    return filter(() => toNum(ckNormeControl.value) === toNum(expectedNorme));
}
